import { createSvgIcon } from '@mui/material/utils';

const FacebookIcon = createSvgIcon(
  <svg viewBox="0 0 14 24">
    <path d="M9.07101 24.0059V13.5039H12.5525L13.2134 9.16199H9.07284V6.34326C9.07284 5.15416 9.65162 3.99492 11.5053 3.99492H13.3887V0.298898C13.3887 0.298898 11.6809 0.00585938 10.0454 0.00585938C6.63495 0.00585938 4.40427 2.08531 4.40427 5.85045V9.16381H0.611328V13.5058H4.40063V24.0059C5.22601 24.0059 5.94253 24.0059 6.73764 24.0059C7.53154 24.0059 8.26576 24.0059 9.07101 24.0059Z" fill='currentColor'/>
  </svg>,
  'Facebook',
);

export default FacebookIcon;
